import { useQuery } from "@tanstack/react-query";

import { MASTER_INVALIDATION_KEY } from "@/api/queryClient";
import { useAuthClaims } from "@/api/resources/auth/hooks";
import { authQueryKeys } from "@/api/resources/auth/queries";
import { usersQueryKeys } from "@/api/resources/users/queries";
import {
  apiConfigUsersToWorkspaces,
  deleteUserToWorkspace,
  updateUserToWorkspace,
} from "@/api/resources/usersToWorkspaces/api";
import { usersToWorkspacesQueries } from "@/api/resources/usersToWorkspaces/queries";
import i18n from "@/providers/i18n";
import { spawnDeleteMutationHook, spawnUpdateMutationHook } from "@/utils/api";

const entity = i18n.t("user");

export const useCurrentUserToWorkspaces = () => {
  const { data: claims } = useAuthClaims();
  return useQuery({
    ...usersToWorkspacesQueries.listByUserId(claims?.sub),
  });
};

export const useUpdateUserToWorkspace = (user_id?: string, workspace_id?: string) =>
  spawnUpdateMutationHook({
    mutationFn: updateUserToWorkspace,
    notifyEntity: entity,
    analyticsEntity: apiConfigUsersToWorkspaces.table,
    invalidationQueryKeys: [
      usersQueryKeys.byId(user_id),
      usersQueryKeys.listWorkspaceUsers(workspace_id),
      // needed because we might be looking at this from the customer page
      // where the workspace_id is not the current workspace_id
      usersQueryKeys.lists(),
      authQueryKeys.getAuthUserPermissions(),
    ],
  })();

export const useDeleteUserToWorkspace = spawnDeleteMutationHook({
  mutationFn: deleteUserToWorkspace,
  notifyEntity: entity,
  analyticsEntity: apiConfigUsersToWorkspaces.table,
  invalidationQueryKeys: [MASTER_INVALIDATION_KEY],
});
